import Component from "./news.component";
import { Config } from "./news.config";
import { watchNews as saga } from "./redux/news.sagas";
import { reducer } from "./redux/news.reducer";

export default { Component, saga, reducer, config: Config };
